const LiechtensteinSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111781)">
      <path
        d="M40 20.0003C40 31.0459 31.0456 40.0003 20 40.0003C8.95437 40.0003 0 31.0459 0 20.0003C0.869531 20.0003 20 17.3916 20 17.3916L40 20.0003Z"
        fill="#D80027"
      />
      <path d="M0 20C0 8.95437 8.95437 0 20 0C31.0456 0 40 8.95437 40 20" fill="#0052B4" />
      <path
        d="M14.7824 13.9141C14.7824 12.4734 13.6145 11.3054 12.1738 11.3054C11.5054 11.3054 10.8963 11.557 10.4346 11.9702V10.4358H11.3041V8.69668H10.4346V7.82715H8.69547V8.69668H7.82594V10.4358H8.69547V11.9702C8.23383 11.557 7.62469 11.3054 6.95633 11.3054C5.51562 11.3054 4.34766 12.4734 4.34766 13.9141C4.34766 14.6865 4.68367 15.3803 5.21719 15.858V17.3924H13.9128V15.858C14.4465 15.3803 14.7824 14.6865 14.7824 13.9141Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111781">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default LiechtensteinSvg;
